declare var jQuery: any;

import { GlobalLoader } from './global_loader';

const scope_overlay_css = {
    background: '#fff',
    opacity: 0.65,
};

function get_scope_block_options() {
    return {
        message: null as null,
        overlayCSS: scope_overlay_css,
        fadeIn: 0,
        fadeOut: 0,
    };
}

export class SpinnerController {
    /** Shopify Platform Settings skin uses area overlays; legacy uses GlobalLoader without inline button spinners. */
    public uses_shopify_area_loader(): boolean {
        return document.body.classList.contains('platform-settings-shopify-theme');
    }

    public toggleSpinnerOnButton(button_element: any, on_off: any = undefined, remove_attr = true) {
        if (jQuery(button_element).find('.temp_spinner').length == 0) {
            const spinner = `<span class="temp_spinner" style="display:flex">
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" stroke="#2196F3" viewBox="0 0 24 24"><script xmlns=""/><style>.spinner_QPB9{transform-origin:center;animation:spinner_4N1C 2s linear infinite}.spinner_QPB9 circle{stroke-linecap:round;animation:spinner_MX3P 1.5s ease-in-out infinite}@keyframes spinner_4N1C{100%{transform:rotate(360deg)}}@keyframes spinner_MX3P{0%{stroke-dasharray:0 150;stroke-dashoffset:0}47.5%{stroke-dasharray:42 150;stroke-dashoffset:-16}95%,100%{stroke-dasharray:42 150;stroke-dashoffset:-59}}</style><g class="spinner_QPB9"><circle cx="12" cy="12" r="9.5" fill="none" stroke-width="3"/></g><script xmlns=""/><script xmlns=""/></svg>
            </span>`;
            jQuery(button_element).append(spinner);
        }

        const temp_spinner = jQuery(button_element).find('.temp_spinner');
        if (on_off) {
            jQuery(button_element).addClass('vm-spinner-wrap');
            jQuery(temp_spinner).show();
            setTimeout(() => {
                jQuery(button_element).attr('disabled', 'disabled');
            }, 100);
        } else {
            jQuery(button_element).removeClass('vm-spinner-wrap');
            jQuery(temp_spinner).hide();

            if (remove_attr) {
                setTimeout(() => {
                    jQuery(button_element).removeAttr('disabled');
                }, 100);
            }
        }
    }

    public addLoadingOverlay() {
        const loadingOverlay = jQuery('#loading-overlay');
        
        if (loadingOverlay.length > 0) {
            loadingOverlay.css('display', 'flex');
        } else {
            const overlay = `
                <div id="loading-overlay" style="display: flex;">
                    <svg xmlns="http://www.w3.org/2000/svg" width="100" height="100" stroke="#2196F3" viewBox="0 0 24 24">
                        <style>
                            .spinner_QPB9 {
                                transform-origin: center;
                                animation: spinner_4N1C 2s linear infinite;
                            }
                            .spinner_QPB9 circle {
                                stroke-linecap: round;
                                animation: spinner_MX3P 1.5s ease-in-out infinite;
                            }
                            @keyframes spinner_4N1C {
                                100% {
                                    transform: rotate(360deg);
                                }
                            }
                            @keyframes spinner_MX3P {
                                0% {
                                    stroke-dasharray: 0 150;
                                    stroke-dashoffset: 0;
                                }
                                47.5% {
                                    stroke-dasharray: 42 150;
                                    stroke-dashoffset: -16;
                                }
                                95%, 100% {
                                    stroke-dasharray: 42 150;
                                    stroke-dashoffset: -59;
                                }
                            }
                        </style>
                        <g class="spinner_QPB9">
                            <circle cx="12" cy="12" r="9.5" fill="none" stroke-width="3"/>
                        </g>
                    </svg>
                </div>
            `;
            jQuery('body').prepend(overlay);
        }
    }
    

    public removeLoadingOverlay() {
        const loadingOverlay = jQuery('#loading-overlay');
        loadingOverlay.css('display', 'none');
    }

    private begin_legacy_save(button_element: any = null, use_global_loader = true): void {
        if (use_global_loader) {
            GlobalLoader.toggle_loader(true);
        }
        if (button_element) {
            this.set_control_busy(button_element, true);
        }
    }

    private end_legacy_save(button_element: any = null, remove_attr = true, use_global_loader = true): void {
        if (use_global_loader) {
            GlobalLoader.toggle_loader(false);
        }
        if (button_element) {
            this.set_control_busy(button_element, false, remove_attr);
        }
    }

    /** Platform Settings cards render inside `.settings_row > .row`; block the card, not the wrapper. */
    private resolve_block_scope(element: any): any {
        const $element = jQuery(element);
        if (!$element.length) {
            return $element;
        }
        if ($element.hasClass('settings_row')) {
            const $card = $element.children('.row').first();
            if ($card.length) {
                return $card;
            }
        }
        return $element;
    }

    /** Area overlay for a card, table, or modal section on Platform Settings (Shopify skin only). */
    public block_element(element: any) {
        if (!this.uses_shopify_area_loader()) {
            return;
        }
        const $element = this.resolve_block_scope(element);
        if (!$element.length || typeof $element.block !== 'function') {
            return;
        }
        const locked_height = $element.outerHeight();
        if (locked_height > 0) {
            $element.data('ps-blockui-lock-height', locked_height);
            $element.css({
                minHeight: locked_height + 'px',
                maxHeight: locked_height + 'px',
                overflow: 'hidden',
            });
        }
        $element.block(get_scope_block_options());
    }

    public unblock_element(element: any) {
        if (!this.uses_shopify_area_loader()) {
            return;
        }
        const $element = this.resolve_block_scope(element);
        if (!$element.length || typeof $element.unblock !== 'function') {
            return;
        }
        $element.unblock(get_scope_block_options());
        if ($element.data('ps-blockui-lock-height')) {
            $element.css({ minHeight: '', maxHeight: '', overflow: '' });
            $element.removeData('ps-blockui-lock-height');
        }
    }

    /** Scope-only block with legacy GlobalLoader fallback when Shopify skin is off. */
    public toggle_scope_block(is_block: boolean, scope: any = null): void {
        if (this.uses_shopify_area_loader()) {
            if (is_block) {
                this.block_element(scope);
            } else {
                this.unblock_element(scope);
            }
            return;
        }
        GlobalLoader.toggle_loader(is_block);
    }

    public show_page_loader() {
        if (this.uses_shopify_area_loader()) {
            this.addLoadingOverlay();
            return;
        }
        GlobalLoader.toggle_loader(true);
    }

    public hide_page_loader() {
        if (this.uses_shopify_area_loader()) {
            this.removeLoadingOverlay();
            return;
        }
        GlobalLoader.toggle_loader(false);
    }

    public begin_page_save(button_element: any = null): void {
        if (this.uses_shopify_area_loader()) {
            this.show_page_loader();
            if (button_element) {
                this.set_control_busy(button_element, true);
            }
            return;
        }
        this.begin_legacy_save(button_element, true);
    }

    public end_page_save(button_element: any = null, remove_attr = true): void {
        if (this.uses_shopify_area_loader()) {
            this.hide_page_loader();
            if (button_element) {
                this.set_control_busy(button_element, false, remove_attr);
            }
            return;
        }
        this.end_legacy_save(button_element, remove_attr, true);
    }

    /** Disable a control without injecting an inline button spinner. */
    public set_control_busy(control_element: any, is_busy: boolean, remove_attr = true) {
        const $control = jQuery(control_element);
        if (!$control.length) {
            return;
        }
        if (is_busy) {
            $control.attr('disabled', 'disabled');
            return;
        }
        if (remove_attr) {
            $control.removeAttr('disabled');
        } else {
            $control.attr('disabled', 'disabled');
        }
    }

    /** Resolve the active Platform Settings modal/slide overlay target. */
    public get_platform_modal_scope(preferred_scope: any = null): any {
        if (preferred_scope) {
            const $preferred = jQuery(preferred_scope);
            if ($preferred.length) {
                return $preferred;
            }
        }

        const wc_main = jQuery('#wc-backbone-modal-dialog .wc-backbone-modal-main');
        if (wc_main.length) {
            return wc_main;
        }

        const slide_view = jQuery('#course-select-slide-view, #display-settings-slide-view').filter(':visible').first();
        if (slide_view.length) {
            return slide_view;
        }

        const settings_modal = jQuery('#settings_modal_id .modal__container');
        if (settings_modal.length) {
            return settings_modal;
        }

        return jQuery('#settings_modal_id');
    }

    public begin_scope_save(scope: any, button_element: any = null): void {
        if (this.uses_shopify_area_loader()) {
            this.block_element(scope);
            if (button_element) {
                this.set_control_busy(button_element, true);
            }
            return;
        }
        this.begin_legacy_save(button_element, true);
    }

    public end_scope_save(scope: any, button_element: any = null, remove_attr = true): void {
        if (this.uses_shopify_area_loader()) {
            this.unblock_element(scope);
            if (button_element) {
                this.set_control_busy(button_element, false, remove_attr);
            }
            return;
        }
        this.end_legacy_save(button_element, remove_attr, true);
    }

    public begin_modal_save(button_element: any = null, preferred_scope: any = null): any {
        const scope = this.get_platform_modal_scope(preferred_scope);
        if (this.uses_shopify_area_loader()) {
            this.begin_scope_save(scope, button_element);
            return scope;
        }
        this.begin_legacy_save(button_element, false);
        return scope;
    }

    public end_modal_save(scope: any, button_element: any = null, remove_attr = true): void {
        if (this.uses_shopify_area_loader()) {
            this.end_scope_save(scope, button_element, remove_attr);
            return;
        }
        this.end_legacy_save(button_element, remove_attr, false);
    }
}
